import { render, staticRenderFns } from "./MegaNav.vue?vue&type=template&id=5230375f&scoped=true&"
import script from "./MegaNav.vue?vue&type=script&lang=js&"
export * from "./MegaNav.vue?vue&type=script&lang=js&"
import style0 from "./MegaNav.vue?vue&type=style&index=0&id=5230375f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5230375f",
  null
  
)

export default component.exports